<main [@routerTransition]="getState(o)" [@.disabled]="true" > <!-- [@.disabled]="true"-->
    <router-outlet  #o="outlet"    ></router-outlet><!-- #o="outlet" -->
    <!-- <img class="parentesis" src="assets/img/Parentesis.svg" alt="parenthesis"> -->
</main>
<div class="intro ">
    <img class="parentesis" src="assets/img/Parentesis.svg" [attr.alt]="'nav.parenthesisAlt' | transloco">
    <canvas class="introCanvas"></canvas>
</div>
<nav class="navigation__menu {{ navColor }}" [ngClass]="{'hide': data.hideheader}" >
    <img [routerLink]="language.link([])" [attr.alt]="'nav.logoAlt' | transloco" routerActive="active" src="assets/img/amvara_web_icon_logo.svg" >
    <div class="header-list">
        <a [routerLink]="language.link([])" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{ 'nav.home' | transloco }}</a>
        <a [routerLink]="language.link(['about'])" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{ 'nav.about' | transloco }}</a>
        <a [routerLink]="language.link(['contact'])" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{ 'nav.contact' | transloco }}</a>
        <div class="lang-switcher"
             [class.lang-switcher--open]="langMenuOpen"
             [attr.aria-label]="'lang.switchAriaLabel' | transloco">
            <!-- Desktop / wide: all languages visible -->
            <div class="lang-switcher__flat" role="group">
                @for (lang of langs; track lang) {
                  <button type="button"
                          class="lang-switcher__btn"
                          [class.active]="language.currentLang() === lang"
                          (click)="switchLang(lang)">{{ ('lang.' + lang) | transloco }}</button>
                }
            </div>
            <!-- Mobile: current language + dropdown -->
            <div class="lang-switcher__dropdown">
                <button type="button"
                        class="lang-switcher__toggle"
                        [attr.aria-expanded]="langMenuOpen"
                        aria-haspopup="listbox"
                        (click)="toggleLangMenu($event)">
                    <span>{{ ('lang.' + language.currentLang()) | transloco }}</span>
                    <span class="lang-switcher__caret" aria-hidden="true"></span>
                </button>
                @if (langMenuOpen) {
                  <ul class="lang-switcher__menu" role="listbox">
                    @for (lang of langs; track lang) {
                      <li role="option" [attr.aria-selected]="language.currentLang() === lang">
                        <button type="button"
                                class="lang-switcher__btn"
                                [class.active]="language.currentLang() === lang"
                                (click)="switchLang(lang, $event)">{{ ('lang.' + lang) | transloco }}</button>
                      </li>
                    }
                  </ul>
                }
            </div>
        </div>
    </div>
</nav>
<a class="legal" [ngClass]="{'hidelegal': data.hidelegal}" (click)="onclick_legal($event)" href="#" [attr.aria-label]="'nav.legalAriaLabel' | transloco">{{ 'nav.legal' | transloco }}</a>
